import {Box, extendTheme, GridItem, Text} from "../_snowpack/pkg/@chakra-ui/react.js";
import * as React from "../_snowpack/pkg/react.js";
export {Box} from "../_snowpack/pkg/@chakra-ui/react.js";
export const Explanation = ({children}) => /* @__PURE__ */ React.createElement(Text, {
  align: "center",
  color: "gray.500",
  fontSize: "sm"
}, children);
export const DateExpression = ({children}) => /* @__PURE__ */ React.createElement(Text, {
  align: "center",
  color: "gray.500"
}, children);
export const Result = ({children, ...props}) => /* @__PURE__ */ React.createElement(Text, {
  align: "center",
  fontSize: "2xl",
  ...props
}, children);
export const Pill = ({children, ...props}) => /* @__PURE__ */ React.createElement(Box, {
  px: 1,
  borderRadius: "xl",
  cursor: "pointer",
  ...props
}, children);
export const SelectedPill = ({children, ...props}) => /* @__PURE__ */ React.createElement(Pill, {
  bg: "cyan.500",
  color: "white",
  ...props
}, children);
export const MidTitle = ({children}) => /* @__PURE__ */ React.createElement(GridItem, {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end"
}, children);
export const ContentItem = ({children}) => /* @__PURE__ */ React.createElement(GridItem, {
  display: "flex",
  justifyContent: "center"
}, children);
export const theme = extendTheme({
  colors: {
    muted: "gray.500",
    accent: "teal.500"
  },
  sizes: {
    1: "0.75rem",
    2: "1rem",
    4: "2rem"
  },
  space: {
    1: "0.75rem",
    2: "1rem",
    4: "2rem"
  }
});
